module.exports = __webpack_public_path__ + "img/jellyfish.be5030ca.webp";